<template>
  <div class="time-scope">
    <div v-if="showWeekSetting">
      <div>
        <el-checkbox :value="weekEnable" @input="weekEnableChange">允许选择的星期</el-checkbox>
      </div>
      <el-select
        v-if="weekEnable"
        :value="enabledDayOfWork"
        multiple
        @input="weekChange"
        style="width: 100%"
      >
        <el-option
          v-for="option in weekOptionList"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        ></el-option>
      </el-select>
    </div>
    <div v-if="showTimeRangeSetting">
      <div>
        <el-checkbox :value="timeRangeEnable" @input="rangeEnableChange">
          允许选择的时段
        </el-checkbox>
      </div>
      <div v-if="timeRangeEnable">
        <el-time-picker
          class="el-time-picker"
          is-range
          :clearable="false"
          :value="timeRangeTransformed"
          :format="timeProps.displayFormat"
          value-format="HH:mm:ss"
          :picker-options="timeProps.pickerOptions"
          @input="timeRangeChange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
        ></el-time-picker>
      </div>
    </div>
    <div v-if="showWeekSetting">
      <div>
        <el-checkbox :value="dateRangeEnable" @input="dateEnableChange">
          允许选择的日期
        </el-checkbox>
      </div>
      <el-select v-if="dateRangeEnable" :value="dataType" placeholder="请选择" @change="clearDate">
        <el-option
          v-for="item in dateTypes.slice(1)"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <div v-if="dateRangeEnable && dataType === 'Now'" style="padding-top: 10px;">
        <el-select
          :value="dataType === 'Now' && value.dateRange.indexOf('Now') === 0 ? 'begin' : 'end'"
          placeholder="请选择"
          @change="submitDateRange"
        >
          <el-option
            v-for="item in timeTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div v-if="dateRangeEnable && dataType === 'Custom'" style="padding-top: 10px;">
        <el-date-picker
          class="el-date-picker"
          :clearable="false"
          :editable="true"
          :value="value.dateRange"
          format="yyyy-MM-dd"
          type="daterange"
          value-format="yyyy-MM-dd"
          @input="dateRangeChange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </div>
    </div>
  </div>
</template>

<script>
import { timeTypeList, weekOptionList, dateTypes, timeTypes } from "./static"

export default {
  name: "time-scope",
  props: {
    value: {
      type: Object,
      default: () => ({
        weekLimit: null,
        timeRange: null,
        dateRange: null
      })
    },
    control: Object
  },
  computed: {
    weekEnable() {
      return this._.isNumber(this.value.weekLimit)
    },
    enabledDayOfWork() {
      if (!this.weekEnable) return []
      let weekLimit = this.value.weekLimit
      let res = []
      for (let i = 0; i < 7; i++) {
        if (weekLimit & (1 << i)) {
          res.push(i)
        }
      }
      return res
    },
    timeRangeEnable() {
      return this._.isArray(this.value.timeRange)
    },
    dateRangeEnable() {
      return this._.isArray(this.value.dateRange)
    },
    timeRangeTransformed() {
      if (!this.value.timeRange) return []
      return this.value.timeRange.map(timeStr => {
        return new Date(2000, 1, 1, ...timeStr.split(":"))
      })
    },
    showWeekSetting() {
      return this.control?.timeType?.includes("日")
    },
    showTimeRangeSetting() {
      return this.control?.timeType?.includes("时")
    },
    timeProps() {
      const timeTypeMap = this._.keyBy(timeTypeList, "value")
      let timeTypeItem = timeTypeMap[this.control.timeType]
      return {
        valueFormat: "HH:mm:ss", // value的格式
        displayFormat: timeTypeItem.timeFormat, // 日期输入框实际展示的格式
        pickerOptions: {
          format: timeTypeItem.timeFormat // 当控件选择时间时,时间的格式
        }
      }
    },
    dataType() {
      return this.value.dateRange?.includes("Now") ? "Now" : "Custom"
    }
  },
  data() {
    return {
      weekOptionList,
      timeTypeList,
      dateTypes,
      timeTypes
    }
  },
  methods: {
    weekEnableChange(enable) {
      let val = this._.cloneDeep(this.value)
      val.weekLimit = enable ? 0xff : null
      this.emitVal(val)
    },
    weekChange(weekSelected) {
      let val = this._.cloneDeep(this.value)
      let weekLimit = 0
      weekSelected.forEach(weekVal => (weekLimit |= 1 << weekVal))
      val.weekLimit = weekLimit
      this.emitVal(val)
    },
    emitVal(val) {
      this.$emit("input", val)
    },
    rangeEnableChange(enable) {
      let val = this._.cloneDeep(this.value)
      val.timeRange = enable ? ["09:00:00", "17:00:00"] : null
      this.emitVal(val)
    },
    dateEnableChange(enable) {
      let val = this._.cloneDeep(this.value)
      val.dateRange = enable ? [] : null
      this.emitVal(val)
    },
    timeRangeChange(timeRange) {
      let val = this._.cloneDeep(this.value)
      val.timeRange = timeRange
      this.emitVal(val)
    },
    dateRangeChange(dateRange) {
      let val = this._.cloneDeep(this.value)
      val.dateRange = dateRange
      this.emitVal(val)
    },
    clearDate(dataType) {
      let val = this._.cloneDeep(this.value)
      val.dateRange = dataType === "Now" ? ["Now", null] : []
      this.emitVal(val)
    },
    submitDateRange() {
      let val = this._.cloneDeep(this.value)
      if (this.type === "begin") {
        val.dateRange = ["Now", null]
      } else {
        val.dateRange = [null, "Now"]
      }
      this.emitVal(val)
    }
  }
}
</script>

<style scoped lang="scss">
.time-scope {
  .el-time-picker {
    width: 100%;
  }
  .el-date-picker {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
}
</style>
